import React, { useCallback } from 'react';
import ArticleCard from './ArticleCard';
import { Article, normalizeDate } from '@/types/Blog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import useEmblaCarousel from 'embla-carousel-react';

interface LatestArticlesProps {
  articles: Article[];
  selectedCategory: string | null;
}

const LatestArticles: React.FC<LatestArticlesProps> = ({ articles, selectedCategory }) => {
  // Sort articles by time (newest first)
  const sortedArticles = [...articles].sort((a, b) => {
    const timeA = new Date(`${normalizeDate(a.date)} ${a.time}`).getTime();
    const timeB = new Date(`${normalizeDate(b.date)} ${b.time}`).getTime();
    return timeB - timeA;
  });
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, align: 'start', containScroll: 'trimSnaps' });

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);


  return (
    <section className="rounded-md bg-white md:w-full w-[90%] relative z-20">
      <h2 className="text-xl font-semibold p-5 rounded-t-md text-center md:text-left">Rekomendasi untuk Anda</h2>
      {sortedArticles.length > 0 ? (
        <div className="relative">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex pb-4 mr-2 ml-2 md:mr-5 md:ml-5 snap-x snap-mandatory gap-3 md:gap-5">
              {sortedArticles.map((article) => (
                <div
                  key={article.slug}
                  className="flex-shrink-0 snap-start w-full sm:w-1/2 md:w-1/3 xl:w-1/4"
                >
                  <ArticleCard article={article} />
                </div>
              ))}
            </div>
          </div>

          <div className="w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-10 pointer-events-none flex md:flex-none justify-between p-10 pt-0 md:p-0">
            <button
              onClick={scrollPrev}
              className="pointer-events-auto absolute -left-12 w-12 h-12 md:-left-20 md:w-20 md:h-20  flex items-center justify-center rounded-full rounded-r-none bg-darkBlue text-white"
            >
              <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '1.25rem' }} />
            </button>
            <button
              onClick={scrollNext}
              className="pointer-events-auto absolute -right-12 w-12 h-12 md:-right-20 md:w-20 md:h-20 flex items-center justify-center rounded-full rounded-l-none bg-darkBlue text-white"
            >
              <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '1.25rem' }} />
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 p-4 rounded text-center">
          <p className="text-gray-500">Tidak ada artikel terkini dalam kategori {selectedCategory || 'ini'}</p>
        </div>
      )}
    </section>
  );
};

export default LatestArticles;